import React from "react";
import { TableFilter, TableFilterType } from "./TableFilter";
import { QueryFilterValue } from "../types";

export type TableFiltersProps = {
  filters: TableFilterType[];
  onFilterChange: (filterName: string, filterValue: QueryFilterValue) => void;
};

export const TableFilters = ({
  filters,
  onFilterChange
}: TableFiltersProps) => {
  return (
    <>
      {filters.map(filter => (
        <TableFilter
          key={filter.name}
          filter={filter}
          onFilterChange={value => onFilterChange(filter.name, value)}
        />
      ))}
    </>
  );
};
